import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ContextualNotFoundComponent } from './shared/components/contextual-not-found/contextual-not-found.component';
import { MobileAdminGuard } from './mobile-admin/mobile-admin.guard';
import { SysadminGuard } from './sysadmin/sysadmin.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./core/containers/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    // The Connector Manager moved under /analytics/connectors (it is a
    // client-facing Analytics view); these keep old deep links and bookmarks
    // working.
    path: 'connector-manager',
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/analytics/connectors' },
      {
        path: ':connectorId/rule/:ruleId',
        redirectTo: '/analytics/connectors/:connectorId/rule/:ruleId',
      },
      {
        path: ':connectorId',
        redirectTo: '/analytics/connectors/:connectorId',
      },
    ],
  },
  {
    path: 'presentation',
    loadChildren: () =>
      import('./presentation/presentation.module').then(
        (m) => m.PresentationModule,
      ),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    data: {
      section: 'admin',
    },
  },
  {
    path: 'source-catalog',
    loadChildren: () =>
      import('./source-catalog/source-catalog.module').then(
        (m) => m.SourceCatalogModule,
      ),
    data: {
      section: 'source-catalog',
    },
  },
  {
    path: 'sysadmin',
    canLoad: [SysadminGuard],
    loadChildren: () =>
      import('./sysadmin/sysadmin.module').then((m) => m.SysadminModule),
    data: {
      section: 'sysadmin',
    },
  },
  {
    path: 'design-system',
    loadChildren: () =>
      import('./design-system/design-system.module').then(
        (m) => m.DesignSystemModule,
      ),
  },
  {
    path: 'mobile-admin',
    canLoad: [MobileAdminGuard],
    loadChildren: () =>
      import('./mobile-admin/mobile-admin.module').then(
        (m) => m.MobileAdminModule,
      ),
    data: {
      section: 'mobile-admin',
    },
  },
  {
    path: '',
    redirectTo: '/analytics/home',
    pathMatch: 'full',
  },
  // ! here is the Catch-all Route for completely invalid paths -> after CoreModule Routes are processed
  { path: '**', component: ContextualNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      enableTracing: false,
      bindToComponentInputs: true, // <-- enable this feature
      scrollPositionRestoration: 'enabled',
      // v22 changed the default to 'always'; pinned to the pre-v22 behaviour so
      // child routes keep seeing only their own params. Revisit deliberately.
      paramsInheritanceStrategy: 'emptyOnly',
    }),
  ], // debug only enableTracing
  exports: [RouterModule],
})
export class AppRoutingModule {}
